<template>
  <div>
    <div class="header-width divcss5">
      <productdetailbanner></productdetailbanner>
    </div>
    <div class=" row body-width divcss5">
      <hsylheader></hsylheader>
    </div>
    <div class=" row body-width divcss5">
      <router-view />
    </div>
  </div>
</template>
<script>
  import productdetailbanner from "@/components//contentcoms/prodecutcontentcoms/productdetailbanner";
  import hsylheader from "@/components/contentcoms/prodecutcontentcoms/hsylxlcp/hsylheader";

  export default {
    name: "producthsyl",
    components: {
      productdetailbanner,
      hsylheader,
    }
  }

</script>



// WEBPACK FOOTER //
// src/pages/producthsyl.vue